import React, { useState, useEffect } from "react";
import { updateTicketStatus, getTicketStatuses } from "../../../../api/ticketing";
import { toast } from "react-toastify";

const STATUS_DOTS = {
  "New":         "#3b82f6",
  "In Progress": "#f59e0b",
  "Reopen":      "#8b5cf6",
  "Resolved":    "#10b981",
  "Rejected":    "#ef4444",
  "Closed":      "#6b7280",
};

const ChangeStatusModal = ({ ticket, onClose, onSaved }) => {
  const token = localStorage.getItem("token");
const [selected, setSelected] = useState(ticket?.status === "Open" ? "New" : ticket?.status || "New");  const [saving, setSaving]     = useState(false);

  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    getTicketStatuses(token)
      .then(res => setStatuses((res.data || []).map(s => ({
        value: s.status,
        dot: STATUS_DOTS[s.status] || "#6b7280",
      }))))
      .catch(() => {});
  }, [token]);

  if (!ticket) return null;

  const handleConfirm = async () => {
    if (selected === ticket.status) { onClose(); return; }
    setSaving(true);
    try {
      await updateTicketStatus(ticket.id, selected, token);
      toast.success(`Status changed to ${selected}`);
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to change status");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1400,
      }} />

      {/* Modal */}
      <div style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff", borderRadius: 12, width: 380,
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)", zIndex: 1401,
        overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "18px 20px 14px", borderBottom: "1px solid #f0f0f0",
        }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>Change Status</span>
          <button onClick={onClose} style={{
            background: "none", border: "none", fontSize: 20,
            cursor: "pointer", color: "#9ca3af", lineHeight: 1,
          }}>×</button>
        </div>

        {/* Status list */}
        <div style={{ padding: "8px 0" }}>
          {statuses.map(s => (
                        <div
              key={s.value}
              onClick={() => setSelected(s.value)}
              style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "10px 20px", cursor: "pointer",
                background: selected === s.value ? "#f0f4ff" : "transparent",
                borderLeft: selected === s.value ? "3px solid #2563eb" : "3px solid transparent",
                transition: "all 0.1s",
              }}
              onMouseEnter={e => { if (selected !== s.value) e.currentTarget.style.background = "#f9fafb"; }}
              onMouseLeave={e => { if (selected !== s.value) e.currentTarget.style.background = "transparent"; }}
            >
              <span style={{
                width: 8, height: 8, borderRadius: "50%",
                background: s.dot, flexShrink: 0,
              }} />
              <span style={{
                fontSize: 13, color: selected === s.value ? "#2563eb" : "#374151",
                fontWeight: selected === s.value ? 600 : 400,
              }}>
                {s.value}
              </span>
              {selected === s.value && (
                <span style={{ marginLeft: "auto", color: "#2563eb", fontSize: 14 }}>✓</span>
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          display: "flex", justifyContent: "flex-end", gap: 10,
          padding: "14px 20px", borderTop: "1px solid #f0f0f0",
        }}>
          <button onClick={onClose} style={{
            padding: "7px 20px", border: "1px solid #d1d5db",
            borderRadius: 6, background: "#fff", color: "#374151",
            fontSize: 13, fontWeight: 500, cursor: "pointer",
          }}>
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={saving} style={{
            padding: "7px 20px", border: "none",
            borderRadius: 6, background: "#2563eb", color: "#fff",
            fontSize: 13, fontWeight: 600, cursor: "pointer",
            opacity: saving ? 0.7 : 1,
          }}>
            {saving ? "Saving..." : "Confirm"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ChangeStatusModal;